<div *ngIf="canView && listAssetsState && listAssetsState.length">
    <h3> Procesos Pendientes en Propiedad Planta y Equipo</h3>
    <ng-container *ngIf="listAssetsState && listAssetsState.length else loading">
        <div *ngFor="let item of listAssetsState">
            <ng-container *ngIf="!item.loading else loading">
                <mat-expansion-panel *ngIf="item.purchaseValue > 0" [hideToggle]="item.list.length === 0 || item.purchaseValue == 0">
                    <mat-expansion-panel-header>
                        <mat-panel-title class="align-items-center">
                            <mat-icon class="icon-help" [matTooltip]="item.informativeMessage" style="margin-right: 6px;">help_outline</mat-icon>
                            <span>{{ item.name }}</span>
                          </mat-panel-title>
                        <mat-panel-description *ngIf="item.list.length > 0 " class="d-flex justify-content-end">
                            {{ item.purchaseValue | currency}}
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    <div *ngFor="let detail of item.list" class="d-flex justify-content-between px-2">
                        <p>{{detail.consecutive}} {{detail.description}}</p>  <p>{{detail.purchaseValue | currency}}</p>
                    </div>
                    <p class="text-center" *ngIf="! item.list.length">{{item.messageEmpty}}</p>
                </mat-expansion-panel>
            </ng-container>
        </div>
    </ng-container>

    <div class="d-flex flex-column justify-content-center box">
        <div class="row header">
            <span class="circle primary"></span>
            <div class="col-12 text-center">
                <b>Nota</b>
            </div>
            <span class="circle primary"></span>
        </div>
        <div id="tabs2">
            Es importante el cargue del <b>ACTA FIRMADA</b> para dar continuidad y afectación al proceso contable, con el cumplimiento de este requisito el proceso quedará en firme.
        </div>
    </div>

    <ng-template #loading>
        <div class='container-hint loading' style="max-width: 600px">
            <div class='content'>
                <div class='stripe small-stripe'>
                </div>
                <div class='stripe medium-stripe'>
                </div>
                <div class='stripe long-stripe'>
                </div>
            </div>
        </div>
    </ng-template>
</div>
